<template>
  <v-app id="app">
    <NavBar></NavBar>
    <v-main>
      <router-view id="main"/>
    </v-main>
    <app-footer></app-footer>
  </v-app>
</template>

<script>

import AppFooter from "@/components/Footer";
import NavBar from "@/components/navbar/NavBar.vue";

export default {
  name: "App",
  components: {NavBar, AppFooter},
  data() {
    return {}
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: "Premium Quality Drywall",
    // all titles will be injected into this template
    titleTemplate: "%s | Premium Quality Drywall",
    meta: [
      {charset: "utf-8"},
      {
        name: "description",
        content: "Professional drywall services in San Fernando Valley. Over 30 years of experience in metal framing, drywall installation, taping, textures, and popcorn ceiling removal. Licensed and bonded. Free estimates.",
      },
      {name: "viewport", content: "width=device-width, initial-scale=1"},
    ],
  },
};
</script>

<style>
#app {
  background: linear-gradient(to bottom, #FAFAFA 0%, #F5F5F5 100%);
  min-height: 100vh;
}
</style>